
interface IMenuItem {
  title: string;
  key: string;
  type?: 'anchor' | 'a';
}

const data: IMenuItem[] = [
  {
    title: '首页',
    key: '/app/home',
  },
  {
    title: '活动日程',
    key: '/app/activitySchedule',
  },
  {
    title: '新闻动态',
    key: '/app/newsList/0',
  },
  {
    title: '历届回顾',
    key: '/app/info',
  }
];


export default data;
